import { useTranslation } from "features/translations";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { Icon, PageLink, Paragraph } from "shared/components";
import { formatTime } from "shared/utils/formatDate";

import styles from "./Item.module.scss";

export const Item = ({ item }) => {
  const { locale } = useRouter();
  const { day, month } = useMemo(() => {
    const day = new Date(item.eventDate).getDate();
    const month = new Date(item.eventDate).getMonth() + 1;
    return { day, month };
  }, [item.eventDate]);
  const { t } = useTranslation();

  const formatCounter = (number) => (number > 9 ? number : `0${number}`);

  const eventStart = useMemo(() => {
    return formatTime(item.eventDate, locale);
  }, [item.eventDate, locale]);

  return (
    <div className={styles.item}>
      <PageLink directory="events" slug={item.slug} className={styles.wrapper}>
        <div className={styles.block}>
          <div className={styles.top}>
            <Paragraph className={styles.category} uppercase>
              {item.eventCategories?.[0].title ?? ""}
            </Paragraph>
            <Paragraph className={styles.title} color="dark" appearance="bold">
              {item.title}
            </Paragraph>
          </div>
          <div className={styles.bottom}>
            <div className={styles.details}>
              {item?.eventType && (
                <Paragraph
                  color="dark"
                  appearance="bold"
                  className={styles.type}
                >
                  <Icon className={styles.icon} name="message" />
                  {t(item.eventType)}
                </Paragraph>
              )}
              {eventStart && (
                <Paragraph
                  color="dark"
                  appearance="bold"
                  className={styles.time}
                >
                  <Icon className={styles.icon} name="clock" />
                  {eventStart}
                </Paragraph>
              )}
            </div>
            <div className={styles.date}>
              <Paragraph
                className={styles.day}
                color="brand"
                appearance="bold"
                plain={true}
              >
                {formatCounter(day)}
              </Paragraph>
              <Paragraph className={styles.month} color="brand" plain={true}>
                /{formatCounter(month)}
              </Paragraph>
            </div>
          </div>
        </div>
      </PageLink>
    </div>
  );
};
